import { SubscriptionType } from '@weave/schema-gen-ts/dist/shared/call-intelligence/plg/subscription_backfill_enums.pb';
import { CallIntelligenceWetags } from '@wetags/call-intelligence';
import { useMatch } from '@frontend/weave-router';
import { BACKFILL_WETAG } from '../../constants';
import { useBackfillStatus } from '../../hooks/use-backfill-status';
import { Batch1GlobalBanner } from './batch1-global-banner';
import { Batch2GlobalBanner } from './batch2-global-banner';
import { MixedGlobalBanner } from './mixed-global-banner';

export const BackfillGlobalBanners = () => {
  const [isWetagEnabled, isWetagLoading] = CallIntelligenceWetags.useWetag(BACKFILL_WETAG);

  const onCallHistoryRoute = !!useMatch({ from: '/calls/call-history', shouldThrow: false });
  const onCallIntelligenceRoute = !!useMatch({ from: '/analytics/call-intelligence', shouldThrow: false });

  const { relevantLocationStatuses, hasBackfillAccess, isLoading, aggregatedBannerState } = useBackfillStatus();

  const {
    isMixedSubscriptionPlan,
    aggregatedSubscriptionType,
    batch1Complete,
    batch2Complete,
    batch2PartialComplete,
    batch2CompleteCount,
    aggregatedBackfillDays,
  } = aggregatedBannerState;

  if (isWetagLoading || !isWetagEnabled || isLoading || !hasBackfillAccess) return null;

  // Priority: MIXED > BATCH-2 > BATCH-1

  // MIXED banner
  if (isMixedSubscriptionPlan && (batch2Complete || batch2PartialComplete || batch1Complete)) {
    return (
      <MixedGlobalBanner
        batchType={batch2Complete || batch2PartialComplete ? 'batch2' : 'batch1'}
        locationCount={batch2Complete || batch2PartialComplete ? batch2CompleteCount : relevantLocationStatuses.length}
        onCallIntelligenceRoute={onCallIntelligenceRoute}
      />
    );
  }

  // BATCH-2 banner (complete or partial)
  if (batch2Complete || batch2PartialComplete) {
    return (
      <Batch2GlobalBanner
        aggregatedSubscriptionType={aggregatedSubscriptionType}
        backfillDays={aggregatedBackfillDays}
        locationCount={batch2CompleteCount}
        isPartial={batch2PartialComplete}
        onCallIntelligenceRoute={onCallIntelligenceRoute}
        onCallHistoryRoute={onCallHistoryRoute}
      />
    );
  }

  // BATCH-1 banner (BASE has no batch-1 banner)
  if (batch1Complete && aggregatedSubscriptionType !== SubscriptionType.SUBSCRIPTION_TYPE_BASE) {
    return (
      <Batch1GlobalBanner
        aggregatedSubscriptionType={aggregatedSubscriptionType}
        onCallIntelligenceRoute={onCallIntelligenceRoute}
      />
    );
  }

  return null;
};
